import { render, staticRenderFns } from "./examinationList.vue?vue&type=template&id=baad275e&scoped=true&"
import script from "./examinationList.vue?vue&type=script&lang=js&"
export * from "./examinationList.vue?vue&type=script&lang=js&"
import style0 from "./examinationList.vue?vue&type=style&index=0&id=baad275e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baad275e",
  null
  
)

export default component.exports